import { render, staticRenderFns } from "./rm-historie.vue?vue&type=template&id=0ff60c1e&scoped=true"
import script from "./rm-historie.vue?vue&type=script&lang=js"
export * from "./rm-historie.vue?vue&type=script&lang=js"
import style0 from "./rm-historie.vue?vue&type=style&index=0&id=0ff60c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff60c1e",
  null
  
)

export default component.exports